<template>
  <v-container fluid class="pa-4">
    <v-card class="pa-4" style="border-radius: 14px;">
      <div class="text-h6 font-weight-bold mb-1">SMS</div>
      <div class="text-body-2 grey--text mb-4">
        Har bir SMS turini yoqish/o'chirish va matnini tahrirlash.
      </div>

      <v-progress-linear v-if="loading" indeterminate rounded class="mb-3" />

      <v-card
        v-for="item in items"
        :key="item.smsKey"
        outlined
        class="mb-3 pa-4"
        style="border-radius: 12px;"
      >
        <div class="d-flex align-start justify-space-between">
          <div class="pr-4">
            <div class="font-weight-medium">
              {{ item.title || item.smsKey }}
              <v-chip x-small label outlined class="ml-2">{{ item.provider }}</v-chip>
            </div>
            <div class="text-caption grey--text mt-1" style="white-space: pre-line;">
              {{ item.description }}
            </div>
          </div>
          <v-switch
            :input-value="item.enabled"
            :loading="savingKey === item.smsKey"
            hide-details
            inset
            class="mt-0"
            @change="(val) => onToggle(item, val)"
          />
        </div>

        <template v-if="item.editable">
          <v-textarea
            v-model="item.template"
            outlined
            dense
            rows="4"
            hide-details
            class="mt-3"
            label="SMS matni"
          />
          <div class="text-caption orange--text text--darken-2 mt-2">
            ⚠️ Bu matn smsxabar provayderida tasdiqlangan shablonga aynan mos bo'lishi shart, aks holda jo'natilmaydi. Placeholderlarni (%s) o'zgartirmang.
          </div>
          <div class="d-flex justify-end mt-2">
            <v-btn
              small
              color="primary"
              :loading="savingKey === item.smsKey"
              @click="onSave(item)"
            >
              {{ $t("Save") }}
            </v-btn>
          </div>
        </template>
        <template v-else>
          <v-textarea
            :value="item.template"
            outlined
            dense
            rows="3"
            hide-details
            readonly
            disabled
            class="mt-3"
            label="SMS matni"
          />
          <div class="text-caption grey--text mt-2">
            Matn provayder shablonida boshqariladi — bu yerda faqat yoqish/o'chirish mumkin.
          </div>
        </template>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AdminSmsSettings",
  data: () => ({
    loading: false,
    savingKey: null,
  }),
  computed: {
    ...mapGetters("admin-sms-settings", ["GET_SMS_SETTINGS"]),
    items: (vm) => vm.GET_SMS_SETTINGS,
  },
  created() {
    this.fetch();
  },
  methods: {
    ...mapActions("admin-sms-settings", ["INIT_SMS_SETTINGS", "UPDATE_SMS_SETTING"]),
    async fetch() {
      this.loading = true;
      await this.INIT_SMS_SETTINGS();
      this.loading = false;
    },
    async onToggle(item, val) {
      this.savingKey = item.smsKey;
      const ok = await this.UPDATE_SMS_SETTING({
        smsKey: item.smsKey,
        enabled: val,
        template: null,
      });
      this.savingKey = null;
      this.notify(ok);
      if (!ok) await this.fetch(); // revert the switch if the save failed
    },
    async onSave(item) {
      this.savingKey = item.smsKey;
      const ok = await this.UPDATE_SMS_SETTING({
        smsKey: item.smsKey,
        enabled: item.enabled,
        template: item.template,
      });
      this.savingKey = null;
      this.notify(ok);
    },
    notify(ok) {
      this.$store.dispatch("SET_SNACKBAR", {
        text: ok ? "Saqlandi" : "Xatolik yuz berdi",
        color: ok ? "success" : "error",
      });
    },
  },
};
</script>
